export default __webpack_public_path__ + "static/media/alliance_im12.379f61af.png";